import React, {Component} from "react";

import Modal from "react-modal";

Modal.setAppElement('#root');

class ModalTemplate extends Component {
    constructor(props) {
        super(props);
        this.state={}
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.props.open !== nextProps.open
            || this.props.children !== nextProps.children
        )
    }

    render() {
        const { children, className } = this.props;
        const { handleClose } = this.props;
        const { open, modalTitle, maxWidth, buttonList } = this.props;

        return (
            <Modal isOpen={open} onRequestClose={handleClose} className={className} overlayClassName="modal-overlay" style={{ content:{ maxHeight: '100vh', overflowY: 'auto'}} } >
                <div className="modal-header">
                    <h5 className={"fs-4"}>{modalTitle}</h5>
                    <button className={"btn btn-close"} onClick={handleClose}></button>
                </div>
                {children}
            </Modal>
        );
    }
}

export default ModalTemplate;
